/* istanbul ignore file */

/**
 *
 * Asynchronously loads the component for AdminPage
 *
 */

import { lazyLoad } from 'utils/loadable';

const AdminPage = lazyLoad(
  () => import('./index'),
  module => module.AdminPage,
);

export default AdminPage;
